export async function fetchObjectInfo(objectDefinitionId) {
  try {
    if (!objectDefinitionId) {
      throw new Error("objectDefinitionId is required");
    }

    const response = await fetch(
      `/o/object-admin/v1.0/object-definitions/${objectDefinitionId}?restrictFields=actions`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          // "x-csrf-token": window.Liferay?.authToken || ""
          "Authorization": "Basic " + btoa("prabhudasu:root"),
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      let err = {};
      try { err = await response.json(); } catch (e) { }
      console.error("Error fetching Object Definition:", err);
      throw new Error(err.title || "Failed to fetch object definition");
    }

    return await response.json();

  } catch (error) {
    console.error("fetchObjectInfo Error:", error);
    throw error;
  }
}
